import React, { PureComponent } from "react"

class AnimationPlayer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      playAnimation: false
    }
    this.playAnimation = this.playAnimation.bind(this)
  }

  playAnimation() {
    this.setState({ playAnimation: true })
  }

  render() {
    const children = this.props.children({
      play: this.playAnimation
    })

    const {
      baseAnimationStyle = {}
    } = this.props

    return (
      <span
        style={{
          transform: "translate3d(0, 0, 0)",
          display: "block",
          ...baseAnimationStyle
        }}
        onAnimationEnd={() => { this.setState({ playAnimation: false }) }}>
        {children}
      </span>
    )
  }
}

export default AnimationPlayer



// WEBPACK FOOTER //
// ./src/components/animation-player/index.jsx